import Event from './Event'

export const Evens = new Event()